import { FunctionComponent } from "react";
import { creditInfo } from "../../../../constants/website";
import CreditImage from '../../../../assets/credit-101.png';
import CreditInfoLine from '../Credit101/CreditInfoLine';


const Credit101: FunctionComponent = () => {
    return (
        <div className="bg-[#F5F5F5] w-full px-8 lg:px-20 py-10">
            <h2 className="text-4xl tracking-wider font-sans font-semibold mb-8">
                Credit 101
            </h2>
            <div className="flex flex-col-reverse lg:flex-row justify-between">
                <div className="lg:w-[45%]">
                    {creditInfo.map(({ title, content }, index) => (
                        <CreditInfoLine
                            key={index}
                            title={title}
                            content={content}
                        />
                    ))}
                </div>
                <div className="lg:w-[45%]">
                    <img src={CreditImage} height={905} width={610} alt="Credit 101" />
                </div>
            </div>
        </div>
    );
};


export default Credit101;


